import { Component } from '@angular/core';
import { ICellRendererParams } from '@ag-grid-community/core';
import { UsCapitalGainsEstimatesListingComponent } from '../../us-capital-gains-estimates-listing.component';

type FundSelectCellRendererComponentParams = ICellRendererParams & {
  parentComponent: UsCapitalGainsEstimatesListingComponent;
};

@Component({
  selector: 'ft-fund-select-all-header-renderer',
  templateUrl: './fund-select-all-header-renderer.component.html',
  styleUrls: ['./fund-select-all-header-renderer.component.scss'],
})
export class FundSelectAllHeaderRendererComponent {
  isCheckboxSelected = false;
  parentComponent: UsCapitalGainsEstimatesListingComponent;

  agInit(params: FundSelectCellRendererComponentParams) {
    this.parentComponent = params.parentComponent;
    this.isCheckboxSelected = this.parentComponent.isSelectAllCheckboxChecked; // On load, maintain the state from its parent.
  }

  /**
   * Handle all fund selection / deselection.
   * Update the parent component 'onRowSelected' method.
   */
  onCheckboxClicked(): void {
    this.isCheckboxSelected = !this.isCheckboxSelected; // When manually clicked, update its state.

    this.parentComponent.onRowSelected({
      isSelected: this.isCheckboxSelected,
    });
  }
}
